
import Vue from 'vue';
import Component from "vue-class-component";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import {SysAdminTemplatesClient, TemplateModel} from "@/api-client";
import {Prop} from "vue-property-decorator";
import AdministrationDetailviewLayout from "@/features/administration/AdministrationDetailviewLayout.vue";
import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";
import toasts from "@/components/Toasts";
import {NavigationGuardNext} from "vue-router/types/router";

interface Props {
    id: string;
    preloadedTemplate: TemplateModel;
}

@Component({
    components: {
        SectionPageHeading,
        AdministrationDetailviewLayout,
        HeadingGroup
    },
    beforeRouteEnter(to, from, next: NavigationGuardNext<ApplicationTemplate>) {
        const props = to.meta!.props as Props;
        Promise.all([
            new SysAdminTemplatesClient().get(to.params.id)
        ]).then(values => {
            props.id = to.params.id;
            props.preloadedTemplate = values[0]
            next();
        }).catch(e => next(e))
    }
})
export default class ApplicationTemplate extends Vue implements Props {

    $refs!: {
        templateJsonContainer: HTMLPreElement;
    }

    @Prop({required: true})
    id!: string;
    @Prop({required: true})
    preloadedTemplate!: TemplateModel;

    template = this.preloadedTemplate;

    copyTemplateJsonToClipboard() {
        const range = document.createRange();
        range.selectNode(this.$refs.templateJsonContainer);

        const selection = window.getSelection()!;
        selection.removeAllRanges();
        selection.addRange(range);

        // Give a little visual feedback of what was selected.
        setTimeout(() => {
            document.execCommand('copy');
            selection.removeAllRanges();
            toasts.success(this.$ls.Administration_ApplicationTemplates_Info_TemplateDataInJsonFormatCopied);
        }, 300);
    }
}
